import React, { useState } from 'react';
import { format } from 'date-fns';
import { nl, enUS, de } from 'date-fns/locale';
import { Calendar as CalIcon } from 'lucide-react';
import { Calendar } from './ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from './ui/popover';

// ma=1 ... zo=0 (JS getDay). Bepaal welke weekdagen de garage gesloten is.
const DAY_TO_DOW = { zo: 0, ma: 1, di: 2, wo: 3, do: 4, vr: 5, za: 6 };
const LOCALES = { nl, en: enUS, de };

const startOfToday = () => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; };
const parseISO = (s) => { if (!s) return undefined; const d = new Date(`${s}T00:00:00`); return isNaN(d) ? undefined : d; };

export function OpeningDayPicker({ value, onChange, openingstijden, maxDays = 90, testid = 'opening-day-picker', lang = 'nl', triggerStyle, triggerClassName, placeholder }) {
  const [open, setOpen] = useState(false);
  const selected = parseISO(value);
  const today = startOfToday();
  const maxDate = new Date(today.getTime() + maxDays * 86400000);

  const closedDows = Object.entries(openingstijden || {})
    .filter(([, v]) => v && v.actief === false)
    .map(([k]) => DAY_TO_DOW[k])
    .filter((n) => n !== undefined);

  const disabled = [
    { before: today },
    { after: maxDate },
    ...(closedDows.length ? [{ dayOfWeek: closedDows }] : []),
  ];

  const handleSelect = (d) => {
    if (!d) return;
    onChange(format(d, 'yyyy-MM-dd'));
    setOpen(false);
  };

  const label = selected ? format(selected, 'dd-MM-yyyy') : (placeholder || 'Kies een datum');

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} className={triggerClassName}
          style={triggerStyle || defaultTrigger}>
          <span style={{ color: selected ? 'inherit' : '#94a3b8' }}>{label}</span>
          <CalIcon size={16} style={{ opacity: 0.6, flexShrink: 0 }} />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" style={{ width: 'auto', padding: 0, zIndex: 9999 }} data-testid={`${testid}-content`}>
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected || today}
          onSelect={handleSelect}
          disabled={disabled}
          locale={LOCALES[lang] || nl}
          weekStartsOn={1}
        />
        <style>{`
          [data-testid="${testid}-content"] .rdp-day_disabled,
          [data-testid="${testid}-content"] button.rdp-button:disabled,
          [data-testid="${testid}-content"] button[disabled][name="day"]{
            text-decoration: line-through !important;
            opacity:.45 !important;
            cursor: not-allowed !important;
          }
        `}</style>
      </PopoverContent>
    </Popover>
  );
}

const defaultTrigger = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
  width: '100%', padding: '10px 12px', borderRadius: 10, border: '1px solid #cbd5e1',
  background: '#fff', color: '#0f172a', fontSize: 14, cursor: 'pointer', textAlign: 'left',
};
